import React from "react";
import { getObjectUseCase, upsertUseCase } from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import SurveyFormPresenter from "./SurveyFormPresenter";
import SurveySchema from "./schemas/SurveySchema.json";
import SurveyForm from "./components/SurveyForm";
import NavBar from "../../../components/navbar";

class SurveyFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new SurveyFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "survey";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  getRecruiterId() {
    return this.props.params.recruiterId;
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  onSubmitForm(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  onClickBack() {
    window.history.back();
  }
  render() {
    const { object } = this.state;
    const params = this.getParams();
    const user = this.getCurrentUser();
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex gap-3 mb-3 align-items-center">
                <button
                  className="rounded-5 p-2 border-0 d-flex align-items-center justify-content-center"
                  style={{
                    width: "2.5rem",
                    height: "2.5rem",
                    backgroundColor: "#dfdfdf",
                  }}
                  onClick={this.onClickBack.bind(this)}
                  aria-label="Go Back"
                >
                  <i className="bi bi-arrow-left-short fs-2 text-dark"></i>
                </button>
                <h1 className="fs-3 fw-bold mb-0" style={{ color: "#D18237" }}>
                  Recruitment Satisfaction Survey
                </h1>
              </div>

              <form onSubmit={this.onSubmitForm.bind(this)}>
                <div className="container mt-3">
                  <div
                    className="card shadow-sm border-0"
                    style={{
                      borderLeft: "6px solid #d18237",
                      borderRadius: "12px",
                    }}
                  >
                    <div
                      className="card-body px-5"
                      style={{ boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}
                    >
                      <div className="mb-3">
                        <label htmlFor="email" className="form-label fw-bold">
                          Email address
                          <span className="text-danger fw-lighter ms-1">*</span>
                        </label>
                        <div className="input-group">
                          <span
                            className="input-group-text border-end-0"
                            style={{ backgroundColor: "#D18237" }}
                          >
                            <i
                              className="bi bi-envelope-fill text-secondary"
                              style={{ color: "#D18237" }}
                            ></i>
                          </span>
                          <input
                            type="email"
                            className="form-control border-start-0"
                            style={{ borderRadius: "0 5px 5px 0" }}
                            id="email"
                            name="email"
                            defaultValue={object?.email || ""}
                            disabled
                            required
                            placeholder="example@domain.com"
                          />
                          <div className="invalid-feedback">
                            Please enter a valid email address.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container">
                  <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                    <div className="row g-3">
                      <SurveyForm
                        schema={SurveySchema}
                        object={this.state.object}
                        onChange={this.onChange.bind(this)}
                      />
                    </div>
                    <div className="mt-4">
                      <button
                        type="submit"
                        className="btn fs-sm me-3 text-white"
                        style={{ backgroundColor: "#d18237" }}
                      >
                        <i className="bi bi-file-earmark-check me-2"></i>SAVE
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-light fs-sm"
                        onClick={this.onClickBack.bind(this)}
                      >
                        GO BACK
                      </button> */}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(SurveyFormPage);
